<template>
  <div class="mt-2 flex items-stretch lg:mt-0">
    <button
      id="accountSelectorToggle"
      :ref="tippyId"
      v-tippy="tippy"
      aria-haspopup="true"
      class="flex items-center outline-none leading-none text-md lg:font-medium"
    >
      <pdl-icon class="mr-1" name="location_on"></pdl-icon>
      <span id="accountSelectorToggle_unitName">{{ accountSelected.name }} - {{ accountSelected.accountNumber }}</span>
      <pdl-icon class="ml-25" size="18" name="arrow_drop_down"></pdl-icon>
    </button>

    <div v-cloak id="account-selector-popover" ref="account-selector-popover" class="text-left p-2">
      <div>
        <pdl-section-header size="sm">
          <template #content>
            <pdl-heading>{{ $t('text.selectALocation') }}</pdl-heading>
          </template>
        </pdl-section-header>

        <div v-if="accountList.length >= 8">
          <label for="account-search" class="form-label text-md">
            {{ $t('text.searchForALocation') }}
          </label>

          <div class="form-group">
            <input id="account-search" v-model="search" type="text" class="form-control" />

            <span class="form-help">
              {{ $t('nav.B2B.accountSelector.enterLocation') }}
            </span>
          </div>
        </div>

        <div v-if="filteredList.length" class="b2b-scroll-list-container min-w-xs">
          <div ref="formWrapper" class="nav-utility-bar-b2b-container__scroll-list">
            <slot v-bind="{accountSelected, selectAccount, filteredList}"></slot>
          </div>
        </div>
        <pdl-callout v-else id="accountSelectorDropdown_emptyState">
          <template #content>
            {{ $t('nav.B2B.accountSelector.cannotFind') }}
          </template>
        </pdl-callout>
      </div>

      <pdl-button tertiary icon-only icon="close" class="tooltip__close" @click="closeTooltip"> </pdl-button>
    </div>
  </div>
</template>
<script>
import find from 'lodash/find';
import sortBy from 'lodash/sortBy';
import {mapMutations} from 'vuex';
import {PdlIcon} from '@pedal/pdl-icon';
import {PdlButton} from '@pedal/pdl-button';
import {PdlHeading, PdlSectionHeader} from '@pedal/pdl-section-header';
import {PdlCallout} from '@pedal/pdl-callout';

export default {
  components: {
    PdlIcon,
    PdlButton,
    PdlHeading,
    PdlSectionHeader,
    PdlCallout,
  },
  props: {
    accountList: {
      type: Array,
      default: () => [],
    },
    tooltipId: {
      type: String,
      default: null,
    },
    shippingDays: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      search: '',
      accountSelected: {
        accountNumber: '',
      },
      tippy: {
        allowHTML: true,
        content: this.getAccountPopoverElement,
        interactive: true,
        trigger: 'click',
        theme: 'flush',
        placement: 'top-start',
        sticky: true,
        appendTo: document.body,
        popperOptions: {
          modifiers: [
            {
              name: 'flip',
              options: {
                flipBehavior: ['top', 'bottom-end'],
              },
            },
          ],
        },
      },
    };
  },

  computed: {
    tippyId() {
      return `tippy_${this.tooltipId}`;
    },
    filteredList() {
      const result = this.accountList.filter((account) => this.matchesSearch(account, this.search));
      return sortBy(result, [(account) => account.name.toLowerCase(), 'accountNumber']);
    },
  },

  mounted() {
    if (this.accountList.length) {
      const activeAccount = find(this.accountList, (account) => {
        return account.active === true;
      });
      this.accountSelected = activeAccount || this.accountList[0];
      this.accountSelected.shippingDays = this.shippingDays;
      this.setB2bUnit(this.accountSelected);
      window.localStorage.setItem('currentUnitId', this.accountSelected.accountNumber);
    }
  },

  methods: {
    displayName(account) {
      return account.name;
    },

    matchesSearch({name, accountNumber}, search) {
      return name.toLowerCase().includes(search.toLowerCase()) || accountNumber.includes(search);
    },

    selectAccount(account) {
      this.accountSelected = account;
      this.setB2bUnit(account);
      this.$nextTick(() => this.$refs.formWrapper.querySelector('form').submit());
    },

    closeTooltip() {
      let el = this.$refs[this.tippyId];

      if (el && el._tippy) {
        el._tippy.hide();
      }
    },

    getAccountPopoverElement() {
      return this.$refs['account-selector-popover'];
    },
    ...mapMutations('user', ['setB2bUnit']),
  },
};
</script>
